import fetch from "../fetch";

export default ({ contactId }) =>
  fetch({
    path: `/ct/contacts/${contactId}/funds`,
  });
